var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "list_video", attrs: { id: "list_video" } }, [
    _c(
      "ul",
      { staticClass: "short-video-ul" },
      _vm._l(_vm.shortVideo, function (item, index) {
        return _c(
          "li",
          {
            key: index,
            attrs: {
              "data-index": item.idx,
              ourl: /^\/play/g.test(item.url)
                ? `https://wapv.sogou.com${item.url}`
                : item.url,
            },
          },
          [
            _vm.routeName === "star" ||
            item.posName ||
            !_vm.starVideo ||
            (_vm.starVideo && index > 5)
              ? _c(
                  "a",
                  {
                    attrs: {
                      "data-report": index,
                      "data-exposed": "false",
                      href:
                        (item.resType === "wechat" ||
                          item.resType === "native") &&
                        !_vm.isSnapShot
                          ? "javascript:void(0);"
                          : item.url,
                      ourl: item.itemUrl,
                      uigs: _vm.getUigs({ item, index }),
                      uigsparams: _vm.getUigsPlayInfo({ item, index }),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.clickOutResult(item, $event)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "video-img" },
                      [
                        item.showTagName
                          ? _c(
                              "span",
                              {
                                staticClass: "collection-tag",
                                style: {
                                  backgroundColor: item.showTagBgColor,
                                  color: item.showTagColor,
                                },
                              },
                              [_vm._v(_vm._s(item.showTagName))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.showTagDesc
                          ? _c(
                              "span",
                              {
                                staticClass: "collection-desc",
                                class: {
                                  short2long: item.showTagType === "short2long",
                                },
                              },
                              [
                                _c("i", { staticClass: "icon-collection" }),
                                _c("i", { staticClass: "collection-num" }, [
                                  _vm._v(_vm._s(item.showTagDesc)),
                                ]),
                              ]
                            )
                          : _c("div", { staticClass: "duration" }, [
                              _vm._v(_vm._s(item.duration)),
                            ]),
                        _vm._v(" "),
                        _c("CoverImage", {
                          attrs: {
                            src: item.picurl,
                            "is-resize": false,
                            index: index,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "video-detail" }, [
                      _c("h3", {
                        staticClass: "short-video-title",
                        domProps: { innerHTML: _vm._s(item.titleCut) },
                      }),
                      _vm._v(" "),
                      _vm.routeName !== "star" ||
                      (_vm.routeName === "star" &&
                        (_vm.starTabName === "video" || !_vm.starTab))
                        ? _c(
                            "div",
                            { staticClass: "other-info" },
                            [
                              _c("SiteIcon", {
                                attrs: {
                                  "icon-img": item.siteicon,
                                  "icon-type": item.iconType,
                                },
                              }),
                              _vm._v(" "),
                              item.sitename
                                ? _c(
                                    "span",
                                    { staticClass: "other-info-site" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.sitename) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.date
                                ? _c(
                                    "span",
                                    { staticClass: "other-info-date" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.date) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticStyle: { display: "none" },
              domProps: { innerHTML: _vm._s("<!--v-->") },
            }),
            _vm._v(" "),
            _vm.$config.debug === "on" && item.header
              ? _c(
                  "div",
                  {
                    class: _vm.debugOpen
                      ? "short-video-debug-info-detail-open"
                      : "short-video-debug-info-detail",
                    on: {
                      click: function ($event) {
                        _vm.debugOpen = !_vm.debugOpen
                      },
                    },
                  },
                  [
                    _c("pre", [
                      _vm._v(_vm._s(JSON.stringify(item.header, " ", 2))),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.showLoading ? _c("div", { staticClass: "loading-result" }) : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }